import { render, staticRenderFns } from "./ConfigFieldChoice.vue?vue&type=template&id=0bb5d25c&"
import script from "./ConfigFieldChoice.vue?vue&type=script&lang=js&"
export * from "./ConfigFieldChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports